//==========================================
//⚠️ Keep index files under 100 lines!
//Split logic into submodules as needed.
//==========================================
import { Modal } from "@vds/modals";
import { ButtonGroup } from "@vds/buttons";
import { useState, useEffect } from "react";
import React from "react";
import { DropdownSelect } from "@vds/selects";
import { RadioBoxGroup } from "@vds-core/radio-boxes";
import { Box } from "@mui/material";
import { Icon } from "@vds/icons";
import Trigger from "./Trigger";
import CustomTimeFrame from "./CustomTimeFrame";
import { useSelector, useDispatch } from "react-redux";
import { useWindowSize } from "../../../hooks/viewportHooks";
import { fetchNotificationGroupsEndPoint } from "../../../../configuration";
import {
  BaseLayoutForRoiModal,
  CreateAlertTitle,
  ContentFrame,
  FrameForHeading,
  FrameForHeadingContainer,
  FrameForHeadingContainerTitleDiv,
  FrameForHeadingContainerToggleDiv,
  AlertNameFrameAndTimeFrame,
  ActionsFrame,
  UserGroupsFrame,
  UserHeadingText,
  UserGroupOptions,
  ActionsInsideFrame,
  InputHeaderTitle,
  AlertNameInputFrame,
  RoiCancelSubmitFrame,
  GreyText,
  ConditionContainer,
  UserGroupContainer,
  AlertPreferences,
  NotificationText,
} from "./stylesRoiModal";
import { Line } from "@vds/lines";
import { Toggle } from "@vds/toggles";
import {
  ListGroup,
  ListGroupItem,
  ListGroupItemSubtitle,
  ListGroupItemTitle,
} from "@vds/lists";
import UsersEllipse from "./UsersEllipse";
import { Loader } from "@vds/loaders";
import { CheckboxGroup } from "@vds/checkboxes";
import {
  fetchRulesByDeviceIdSuccess,
  createRule,
  fetchRulesByDeviceIdRequest,
  fetchCountryIdsRequest,
  fetchRulesWithoutRoiRequest
} from "../../../../store/actions";
import {
  getFullCVAppName,
  getLocationByCamera,
  getLocationByTag,
  getTimeAbbreviation,
} from "../../../utility/Utils";
import {
  getAlertEventInfo,
  getCustomerMessage,
  getcvAppDetails,
  getcvAppImage,
  getCvAppTitle,
  getCVAppType,
  getLocationHierarchyWithIds,
} from "../../../utility/cvAppUtils";
import axiosInstance from "../../../axiosInterceptor";
import UniqueNameInput from "../../UniqueNameInput";
import {
  CVAPP_DWELLTIME,
  CVAPP_PROXIMITY,
  CVAPP_UNOBJECTDETECTION,
  CV_APP_TYPE_EVENT
} from "../../../constants/cvappConstants";
import { Notification } from "@vds/notifications";
import { ALERT_ACTIONS } from "../../../constants/alertActionConstants";

const RoiModal = ({
  isModalOpen,
  closeRuleModal,
  cvApp,
  cameraId,
  cvappid,
  roiid,
  fovid,
  companionid,
  areaName,
  EEAppName,
  data,
  tagIds,
  mode
}) => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const { appSelected } = useSelector((state) => state.ruleReducer);
  const { width: viewportWidth } = useWindowSize();
  const isSmallScreen = (viewportWidth ?? 1400) < 768;
  const dispatch = useDispatch();
  const cvAppList = useSelector((state) => state.cvAppReducer.cvAppList);
  const { cameraList, fovList } = useSelector((state) => state?.deviceReducer);
  const [triggerData, setTriggerData] = useState({ condition: "", value: "" });
  const [customData, setCustomData] = useState([]);
  const [notificationUsers, setNotificationUsers] = useState([]);
  const [selectedRadio, setSelectedRadio] = useState("Always active");
  const [loading, setLoading] = useState(true);
  const [apiLoading, setApiLoading] = useState(false);
  const [all, setAll] = useState(false);
  const [ruleName, setRuleName] = useState("");
  const [severity, setSeverity] = useState("");
  const [groups, setGroups] = useState("");
  const [users, setUsers] = useState([]);
  const [sms, setSms] = useState(true);
  const [email, setEmail] = useState(true);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const [timeFrame, setTimeFrame] = useState("Always active");
  const [startTime, setStartTime] = useState([]);
  const [endTime, setEndTime] = useState([]);
  const [timeZone, setTimeZone] = useState("ET");
  const [showTimeFrame, setShowTimeFrame] = useState(false);
  const [enableNotification, setEnableNotification] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isValidAlertName, setIsValidAlertName] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const alertList =
    useSelector((state) => state.polygonRoiReducer.rulesByDeviceId) || [];
  const rulesLists = useSelector((state) => state.polygonRoiReducer.rulesData) || [];
  const fetched = useSelector((state) => state.polygonRoiReducer.fetched);
  const sitesTagList = useSelector((state) => state.sitesReducer.siteTagList);
  const tagAllLists = useSelector((state) => state?.sitesReducer.tagIdList);
  const cvAppType = getCVAppType(cvAppList, cvappid);
  const appName = getFullCVAppName(cvappid, cvAppList) || appSelected?.name;
  const [isVideoEvidenceCapture, setIsVideoEvidenceCapture] = useState(mode === 'edit' ? data?.isVideoEvidenceCapture ?? true : true); 

  useEffect(() => {
    if ((!fetched && rulesLists?.length === 0) || rulesLists?.length === 0) {
      dispatch(fetchRulesWithoutRoiRequest());
    }
  }, [dispatch, fetched]);

  const [showDuration, setShowDuration] = useState(false);

  //commenting for future use
  // const selectedColorCondition = generateConditionString(
  // cvApp === CVAPP_PPEUSAGE
  //   ? triggerData?.checkBoxData
  //   : triggerData?.selectedColors,
  //   triggerData?.selectedColors,
  //   cvappid,
  //   cvAppList,
  //   cvApp,
  //   triggerData?.numberOfColors
  // );
  const handleToggle = () => {
    setAll(!all);
  };
  const handleTriggerData = (data) => {
    //console.log(data,"TRIGGER DATA")
    setTriggerData(data);
  };
  const handleCustomTimeData = (data) => {
    //console.log(data,"CUSTOM DATA")
    setCustomData(data);
  };
  const handleGroupChange = (option) => {
    setEnableNotification(true);
    setSelectedUsers((prevSelected) => {
      const isAlreadySelected = prevSelected.some(
        (group) => group?.label === option?.label
      );
      let updatedSelectedUsers;
      if (isAlreadySelected) {
        updatedSelectedUsers = prevSelected.filter(
          (group) => group.label !== option?.label
        );
        return prevSelected.filter((group) => group?.label !== option?.label);
      } else {
        updatedSelectedUsers = [...prevSelected, option];
      }
      return updatedSelectedUsers;
    });
  };

  useEffect(() => {
    const updatedGroupNames = selectedUsers
      ?.map((group) => group.label)
      .join(",");
    setGroups(updatedGroupNames);
    if (updatedGroupNames?.length > 0) {
      setEnableNotification(true);
    } else {
      setEnableNotification(false);
    }
  }, [handleGroupChange]);

  useEffect(() => {
    if (selectedRadio === "RB2") {
      setTimeFrame(customData?.selectedDays);
      setStartTime(customData?.startTime);
      setEndTime(customData?.endTime);
      setTimeZone(customData?.timeZone);     
    }
  }, [customData]);
  useEffect(() => {
    if (selectedRadio === "RB2") {
      setShowTimeFrame(true);
    } else {
      setShowTimeFrame(false);
    }
  }, [selectedRadio]);

  useEffect(() => {
    if (triggerData?.checkboxData?.checked == true) {
      setShowDuration(true);
    } else {
      setShowDuration(false);
    }
  }, [triggerData]);

  const handleRadioChange = (event) => {
    const value = event.target.value;
    if (value === "Always active") {
      setTimeFrame("Always active");
    }
    setSelectedRadio(event.target.value);
  };
  const fetchNotificationGroups = async () => {
    try {
      const response = await axiosInstance.post(
        fetchNotificationGroupsEndPoint(),
        {
          accountname: activeSession.accountId,
        }
      );
      const data = response.data;
      const groupNames = data?.map((item) => {
        const allUsers = item?.users?.map((user) => ({
          name: `${user?.firstname} ${user?.lastname}`,
          email: user?.email,
          number: user?.mdn,
        }));
        const displayedUsers = allUsers?.slice(0, 6).map((user) => user?.name);
        return {
          label: item?.name,
          value: item?.name,
          displayedUsers: displayedUsers?.join(", "),
          allUsers,
          hasMoreUsers: allUsers?.length > 6,
        };
      });
      setNotificationUsers(groupNames);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Failed to fetch notification groups", error);
    }
  };

  useEffect(() => {
    fetchNotificationGroups();
  }, []);

  const dispatchWithPromise = () => {
    return new Promise((resolve) => {
      dispatch(fetchCountryIdsRequest(resolve));
    });
  };

  useEffect(() => {
    if (!sitesTagList || !tagAllLists) {
      dispatchWithPromise().then(() => { });
    }
  }, [tagAllLists, sitesTagList]);

  useEffect(() => {
    if (
      cvApp === CVAPP_PROXIMITY &&
      triggerData?.showBanner == true &&
      !isNaN(triggerData?.value)
    ) {
      setShowBanner(true);
    } else {
      setShowBanner(false);
    }
  }, [cvApp, triggerData]);

  const ruleCreate = async () => {
    try {
      setApiLoading(true);
      const updatedTagId =
        cvAppType === CV_APP_TYPE_EVENT
          ? getLocationByCamera(cameraId, cameraList)?.areaId
          : Array.isArray(tagIds)
            ? tagIds[0]
            : tagIds;

      const updatedLocationHierarchy = getLocationHierarchyWithIds(
        sitesTagList,
        Array.isArray(updatedTagId) ? updatedTagId[0] : updatedTagId
      );
      const updatedLocationTag = getLocationByTag(
        tagAllLists,
        Array.isArray(updatedTagId) ? updatedTagId[0] : updatedTagId
      );

      let payload = {
        activeSession: activeSession,
        cvappid: cvappid,
        cvAppName: cvappid ? appName : cvApp,
        severity: severity,
        timeFrame: timeFrame,
        groups: groups,
        startTime: startTime,
        endTime: endTime,
        ruleName: ruleName,
        sms: sms,
        email: email,
        cameraId: cameraId,
        triggerData: triggerData,
        showTimeFrame: showTimeFrame,
        condition:
          triggerData?.condition?.length > 0
            ? `${appName ? appName : appSelected?.name} ${triggerData?.condition
            } ${triggerData?.value}`
            : `${cvApp} ${"Detected"}`,
        expression: getcvAppDetails(cvAppList, cvappid),
        triggerData: triggerData,
        fovid: fovid,
        companionid: companionid,
        cvappImage: getcvAppImage(cvAppList, cvappid),
        customerMessage: getCustomerMessage(cvAppList, cvappid),
        title: getCvAppTitle(cvAppList, cvappid),
        aggregateRule: false,
        eventinfo: getAlertEventInfo(
          cvAppList,
          cvappid,
          updatedLocationTag?.name,
          triggerData?.condition && triggerData?.value,
          triggerData?.condition && triggerData?.condition,
          `${triggerData?.value}${getTimeAbbreviation(triggerData?.time)}`
        ),
        addUnits: cvApp === CVAPP_DWELLTIME ? true : false,
        triggerData: triggerData,
        addCoolDownPeriod: triggerData?.addCoolDownPeriod,
        coolPeriodValue: triggerData?.addCoolDownPeriod ? triggerData?.coolPeriodValue : "",
        tagid: updatedLocationTag?.id,
        location: updatedLocationHierarchy,
        isEventApp: cvAppType === CV_APP_TYPE_EVENT ? true : false,
        conditionOperator: triggerData?.condition,
        conditionValue: triggerData?.value,
        captureVideoEvidence: isVideoEvidenceCapture,
        timeZone: timeZone
      };
      if (cvApp === CVAPP_DWELLTIME) {
        payload.duration = `${triggerData?.value}${getTimeAbbreviation(
          triggerData?.time
        )}`;
      }
      if (EEAppName) {
        payload.EEAppName = EEAppName;
      }
      if (roiid) {
        payload.roiid = roiid;
        dispatch(createRule(payload));
      } else {
        payload.action = ALERT_ACTIONS.CREATE;
        const updatedAlertList =
          Array.isArray(alertList) &&
            alertList.length > 0
            ? [...alertList, payload]
            : [payload];
        dispatch(fetchRulesByDeviceIdSuccess(updatedAlertList));
      }
      closeRuleModal();
    } catch (error) {
      console.log("Getting error", error);
    } finally {
      setApiLoading(false);
    }
  };
  const handleValidation = () => {
    const isTriggerDataValid =
      triggerData?.enable === true ||
      (triggerData?.condition !== "" &&
        triggerData?.value !== "" &&
        triggerData?.showBanner === false &&
        (triggerData?.validTime === false ||
          (triggerData?.validTime === true && triggerData?.time !== "")));
    const isTimeFrame =
      selectedRadio !== "RB2" ||
      (selectedRadio === "RB2" && customData?.selectedDays?.length > 0);

    // const isChecked =triggerData?.checkboxData?.checked ===true;
    // const isCheckedValid = isChecked ?  triggerData?.checkboxData?.checkedCondition !=='' &&
    // triggerData?.checkboxData?.checkedTime !=='' && triggerData?.checkboxData?.checkedValue !=='':true;
    return (
      ruleName !== "" &&
      severity !== "" &&
      isTriggerDataValid &&
      isTimeFrame &&
      isValidAlertName
    );
  };

  useEffect(() => {
    setIsFormValid(handleValidation());
  }, [
    severity,
    triggerData,
    selectedUsers,
    ruleName,
    customData,
    selectedRadio,
    isValidAlertName,
  ]);

  return (
    <>
      <Modal
        opened={isModalOpen}
        surface="light"
        width={isSmallScreen ? "calc(100vw - 32px)" : "780px"}
        fullScreenDialog={false}
        disableAnimation={false}
        disableOutsideClick={true}
        ariaLabel="Testing Modal"
        onOpenedChange={(opened) => {
          if (!opened) {
            closeRuleModal();
          }
        }}
        closeButton={
          <Box
            component="button"
            type="button"
            sx={{
              cursor: "pointer",
              position: "absolute",
              right: "25px",
              top: "25px",
              background: "none",
              border: "none",
              padding: 0,
              zIndex: 10
            }}
            onClick={closeRuleModal}
          >
            <Icon name="close" />
          </Box>
        }
      >
        {showBanner == true && (
          <Notification
            type="error"
            fullBleed={false}
            title={"Error"}
            subtitle={`The maximum distance that this app is set to detect is ${data?.max}ft. Please lower the number in the condition or modify the maximum distance in Advanced Configuration.`}
            disableFocus={false}
            hideCloseButton={true}
          />
        )}
        <BaseLayoutForRoiModal>
          <FrameForHeading>
               <Box sx={{ p: 2, width: "100%", padding: "none !important" }}>
                      <FrameForHeadingContainer>
                        
                          <FrameForHeadingContainerTitleDiv>
                          <CreateAlertTitle>Create alert</CreateAlertTitle>
                           
                           
                  <FrameForHeadingContainerToggleDiv>
                
                {cvAppType === CV_APP_TYPE_EVENT && <Toggle
                  on={isVideoEvidenceCapture}
                  surface="light"
                  showText={true}
                  textWeight="regular"
                  textSize="small"
                  textPosition="right"
                  statusText={(e) => (e ? "Capture Video Evidence" : "Capture Video Evidence")}
                  data-testid="ruleDetails_CaptureVideoEvidenceToggle"
                  onChange={(e) => {
                    setIsVideoEvidenceCapture(!isVideoEvidenceCapture);
                  }}
                />}
               </FrameForHeadingContainerToggleDiv>
                         
                       </FrameForHeadingContainerTitleDiv>
              
                        
                      </FrameForHeadingContainer>
                    </Box>
          </FrameForHeading>

          <ContentFrame>
            <AlertNameFrameAndTimeFrame>
              <InputHeaderTitle>Name</InputHeaderTitle>
              <AlertNameInputFrame>
                <UniqueNameInput
                  label="Alert name"
                  defaultValue={ruleName}
                  onChange={(e) => {
                    setRuleName(e.target.value);
                  }}
                  error={isError}
                  isError={isError}
                  setIsError={setIsError}
                  dataList={[...alertList, ...rulesLists]}
                  setIsValid={setIsValidAlertName}
                />
              </AlertNameInputFrame>
            </AlertNameFrameAndTimeFrame>
            <Line type="secondary" />

            <Trigger
              EventTrigger={cvApp}
              onDataChange={handleTriggerData}
              action={true}
              data={data}
              cvappid={cvappid}
              cvAppList={cvAppList}
            />

            <AlertNameFrameAndTimeFrame Action={true}>
              <GreyText>Time frame</GreyText>
              <ConditionContainer>
                <AlertNameInputFrame timeFrame={true}>
                  <RadioBoxGroup
                    orientation="horizontal"
                    data={[
                      {
                        id: "RB1",
                        value: "Always active",
                        text: "Always active (default)",
                        subtext: "Always receive alerts",
                        type: "radioBox",
                        name: "RadioBoxGroup1",
                        onChange: () =>
                          handleRadioChange(
                            "Always active (default) Always receive alerts"
                          ),
                        selected:
                          selectedRadio ===
                          "Always active (default) Always receive alerts",
                      },
                      {
                        id: "RB2",
                        value: "RB2",
                        text: "Custom time frame",
                        subtext: "Choose hours & days of the week",
                        type: "radioBox",
                        name: "RadioBoxGroup2",
                        onChange: () =>
                          handleRadioChange(
                            "Custom time frame Choose hours & days of the week "
                          ),
                        selected:
                          selectedRadio ===
                          "Custom time frame Choose hours & days of the week ",
                      },
                    ]}
                    value={selectedRadio}
                    onChange={handleRadioChange}
                  />

                  {selectedRadio === "RB2" && (
                    <CustomTimeFrame onDataChange={handleCustomTimeData} />
                  )}
                </AlertNameInputFrame>
              </ConditionContainer>
            </AlertNameFrameAndTimeFrame>
            <Line type="secondary" />
            <ActionsFrame>
              <InputHeaderTitle>Actions</InputHeaderTitle>
              <ActionsInsideFrame>
                <ConditionContainer>
                  <DropdownSelect
                    label="Severity"
                    errorText="Select a state"
                    error={false}
                    disabled={false}
                    readOnly={false}
                    inlineLabel={false}
                    width="233px"
                    onChange={(e) => {
                      setSeverity(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    <option>Critical</option>
                    <option>Minor</option>
                  </DropdownSelect>
                </ConditionContainer>
                <NotificationText>Notifications</NotificationText>
                <UserHeadingText>
                  Select all user groups to notify.
                </UserHeadingText>
                <ConditionContainer>
                  <UserGroupsFrame style={{ display: "flex" }}>
                    <UserGroupContainer>
                      <UserGroupOptions style={{ flex: 1 }}>
                        {loading ? (
                          <Loader active fullscreen={false} surface="light" />
                        ) : (
                          ""
                        )}
                        <ListGroup
                          topLine={false}
                          bottomLine={false}
                          surface="light"
                          viewport="mobile"
                        >
                          {notificationUsers?.map((option, index) => {
                            return (
                              <ListGroupItem
                                key={index}
                                actionElement="checkbox"
                                topLine={false}
                                bottomLine={false}
                                onClick={() => handleGroupChange(option)}
                              >
                                <ListGroupItemTitle bold={false}>
                                  {option?.label}
                                </ListGroupItemTitle>
                                {option?.label && (
                                  <ListGroupItemSubtitle
                                    onChange={(e) => setUsers(option)}
                                  >
                                    <UsersEllipse
                                      group={option}
                                      handleToggle={handleToggle}
                                      all={all}
                                    />
                                  </ListGroupItemSubtitle>
                                )}
                              </ListGroupItem>
                            );
                          })}
                        </ListGroup>
                      </UserGroupOptions>
                    </UserGroupContainer>
                    <AlertPreferences style={{ flex: 1 }}>
                      <div>
                        <UserHeadingText>
                          Notification Preferences
                        </UserHeadingText>
                        <CheckboxGroup
                          Surface="light"
                          data={[
                            {
                              disabled: !enableNotification,
                              children: "SMS",
                              value: "Apple (25)",
                              width: "auto",
                              selected: enableNotification && sms,
                              onChange: () => setSms(!sms),
                            },
                            {
                              disabled: !enableNotification,
                              children: "Email",
                              value: "Google (3)",
                              width: "auto",
                              selected: enableNotification && email,
                              onChange: () => setEmail(!email),
                            },
                          ]}
                          className="d-flex flex-lg-row align-items-baseline gap-4 m-0 p-0"
                        />
                      </div>
                    </AlertPreferences>
                  </UserGroupsFrame>
                </ConditionContainer>
              </ActionsInsideFrame>
            </ActionsFrame>

            <RoiCancelSubmitFrame>
              <ButtonGroup
                childWidth={"100%"}
                viewport={"desktop"}
                rowQuantity={{ desktop: 2 }}
                data={[
                  {
                    children: apiLoading ? "Loading..." : "Submit",
                    size: "large",
                    use: "primary",
                    width: "335px",
                    disabled: !isFormValid || apiLoading,
                    onClick: ruleCreate,
                  },
                  {
                    children: "Cancel",
                    size: "large",
                    use: "secondary",
                    width: "335px",
                    onClick: closeRuleModal,
                  },
                ]}
              />
            </RoiCancelSubmitFrame>
          </ContentFrame>
        </BaseLayoutForRoiModal>
      </Modal>
    </>
  );
};

export default RoiModal;
